import type { SimpleCardFragment } from '../graphql/fragments/simple-card.gql-types';
import type { SimpleCompanyItem } from '../types';

type WrappedSimpleCompanyCard = {
  company: SimpleCardFragment;
};
export const createSimpleCompany = (
  companyWrapper: WrappedSimpleCompanyCard
): SimpleCompanyItem | undefined => {
  const { company } = companyWrapper;
  if (!company || !company.id) {
    return undefined;
  }
  return {
    id: company.id,
    name: company.companyName ?? '',
    companyUrl: company.links?.public ?? undefined,
    hasOpenJobs: !!company.jobsCount && company.jobsCount >= 0,
    profileImageUri: company.logos?.logo128px ?? undefined,
    industry: company.industry?.localizationValue,
    location: company.address?.city ?? undefined,
  };
};
export const createSimpleCompanies = (
  companies: WrappedSimpleCompanyCard[]
): SimpleCompanyItem[] =>
  companies
    .map(createSimpleCompany)
    .filter((el): el is SimpleCompanyItem => !!el);
